<template>
	<div class="lista2">
		<ais-instant-search-ssr ref="aisInstantSearchSsr" :insights="true">
			<div class="backdrop" @click="triggerNav()" id="backdrop"></div>

			<ais-breadcrumb :attributes="['categoria_hierarquical.lvl0', 'categoria_hierarquical.lvl1', 'categoria_hierarquical.lvl2']" class="mb-4 hidden md:block">
				<template v-slot:separator>/</template>
			</ais-breadcrumb>

			<div class="panels">
				<div class="left-panel" id="leftPanel">
					<ais-panel v-for="(filtro, $f) in filtrosLaterais" :key="$f">
						<template v-slot:header="{ hasRefinements }">
							<div v-if="hasRefinements" class="head-bold font-20 grey500">{{ filtro.title }}</div>
						</template>
						<template v-slot:default>
							<ais-refinement-list :attribute="filtro.value" :limit="20" :sort-by="['isRefined', 'name']" searchable :searchable-placeholder="filtro.searchPlaceholder || 'Busca'">
								<template v-slot:noResults>
									<div class="head-regular">Nenhum filtro encontrado.</div>
								</template>
							</ais-refinement-list>
						</template>
					</ais-panel>

					<ais-panel>
						<template v-slot:header="{ hasRefinements }">
							<div v-if="hasRefinements" class="head-bold font-20 grey500">Categorias</div>
						</template>
						<template v-slot:default>
							<ais-hierarchical-menu :attributes="['categoria_hierarquical.lvl0', 'categoria_hierarquical.lvl1', 'categoria_hierarquical.lvl2']" />
						</template>
					</ais-panel>

					<ais-configure
						:hitsPerPage="8"
						:clickAnalytics="true"
						:distinct="true"
						:attributesToRetrieve="[
							'*',
							'-ano',
							'-ano_ate',
							'-ano_de',
							'-categoria',
							'-codigobarras',
							'-codigosoriginais',
							'-comentario',
							'-descricao_secundaria',
							'-departamento',
							'-garantia_produto',
							'-grupo',
							'-modelo',
							'-preco_avg',
							'-preco_desconto_tag',
							'-preco_promocional',
							'-qtde_aplicacoes',
							'-resumo_aplicacao',
							'-secao',
							'-segmento',
							'-subgrupo',
							'-veiculo',
						]"
					/>
				</div>
				<div class="right-panel px-4 md:px-0">
					<div class="flex flex-column marketing-info" ref="marketingInfo" v-if="itemMarketingSelecionado">
						<h1 class="grey500">{{ itemMarketingSelecionado.body.h1 }}</h1>
						<div class="flex">
							<h2 class="head-regular color-grey-6a">
								{{ itemMarketingSelecionado.body.descricao }}
							</h2>
						</div>
					</div>

					<ais-search-box id="searchbox">
						<template v-slot="{ currentRefinement, refine }">
							<form @submit.prevent class="ais-SearchBox-form">
								<input type="search" placeholder="Busque pelo seu produto ou pelo código original da peça" id="inputSearch" :value="currentRefinement" class="ais-SearchBox-input" @keypress.enter="refineSearch(refine, $event.currentTarget.value)" />

								<button class="lupa-busca" @click="triggerSearchButton(refine)">
									<img :src="`/custom/loja/assets/media/icons/lupa-primaria.svg`" />
								</button>

								<!-- Para limpar os refinements quando a pessoa faz uma nova busca -->
								<ais-clear-refinements id="clearRefinementSearch" class="hidden" />
							</form>
						</template>
					</ais-search-box>

					<ais-stats class="my-4">
						<template v-slot="{ nbHits }">
							<div class="encontramos-text head-regular">
								Encontramos <b class="head-bold">{{ nbHits }}</b> produtos.
							</div>
						</template>
					</ais-stats>

					<div class="my-4 md:hidden">
						<button class="btn__primary" @click="triggerNav()">Filtrar</button>
					</div>
					<ais-current-refinements>
						<template v-slot:item="{ item, refine, createURL }">
							<div class="current-refinement-chip" v-for="refinement in item.refinements" :key="[refinement.attribute, refinement.type, refinement.value, refinement.operator].join(':')">
								<a :href="createURL(refinement)" @click.prevent="refine(refinement)" class="text-regular">
									{{ formatRefinementLabel(item.label.charAt(0).toUpperCase() + item.label.slice(1)) }}: &nbsp;{{ refinement.label.charAt(0).toUpperCase() + refinement.label.slice(1) }} &nbsp;&nbsp;<svg
										role="img"
										width="12"
										height="12"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg"
										fill="currentColor"
									>
										<path d="m10.466 2.473-.94-.94L6 5.06 2.474 1.533l-.941.94L5.06 6 1.533 9.527l.941.94L6 6.94l3.526 3.527.94-.94L6.94 6z"></path>
									</svg>
								</a>
							</div>
						</template>
					</ais-current-refinements>

					<!-- Aviso Localização -->
					<!-- Bug do f5 -->
					<!-- <client-only>
						<div v-if="!selecionouCidade" class="my-4 p-4 bg-primary flex flex-column items-center justify-center gap-4 lg1220:flex-row">
							<div class="head-regular text-white text-center">Informe seu <b class="head-bold">CEP</b> ou faça seu login para ver produtos em estoque mais perto de você.</div>

							<div class="flex flex-column gap-4">
								<button class="btn__featured" @click="meLocalize()"><i class="fas fa-map-marker-alt"></i>Minha localização</button>
							</div>
						</div>

						<div v-else class="encontramos-text head-regular mt-4 p-4 bg-primary hidden lg1220:block" style="line-height: 19px; color: #fff">
							<i class="fas fa-map-marker-alt mr-2"></i>Você está vendo produtos de concessionárias com estoque mais próximas de: <b class="head-bold" style="color: #fff">{{ cidadeEstado }}</b>
						</div>
					</client-only> -->

					<ais-hits>
						<template v-slot="{ items }">
							<div class="ais-Hits-list" v-if="items.length > 0">
								<ProductListItemV2 v-for="(item, $i) in items" :key="$i" @linkCardProdutoClick="triggerAlgoliaClick" :item="item" :produtoIndex="$i" :availableStores="availableStores" :geolocation="geolocation" />
							</div>
							<div v-if="items.length === 0">
								<div class="head-bold grey500 mb-2">Não há produtos que correspondam à sua busca. Por favor, tente o seguinte:</div>
								<ul class="default-list head-regular color-grey-6a mb-4">
									<li>Revise a <b class="head-bold">ortografia</b> da palavra.</li>
									<li>Utilize palavras mais genéricas ou menos palavras.</li>
									<li class="flex">
										<b class="head-bold"
											><ais-clear-refinements :included-attributes="atributosParaLimpar">
												<template v-slot="{ refine, createURL }">
													<button class="link">
														<span>
															<a :href="createURL()" @click.prevent="clearQuery(refine)">Limpe</a>
														</span>
													</button>
												</template>
											</ais-clear-refinements></b
										>
										&nbsp;os filtros e categorias selecionadas.
									</li>
								</ul>
							</div>
						</template>
					</ais-hits>
					<ais-pagination />
				</div>
			</div>
		</ais-instant-search-ssr>
	</div>
</template>

<script>
import Loader from "@/components/Common/Loader"
import axios from "axios"
import qs from "qs"

let filtroLateralCategorias
let decodeString

const ALGOLIA_INDEX_PRODUCTS = process.env.ALGOLIA_INDEX_PRODUCTS
const ALGOLIA_APPLICATION_ID = process.env.ALGOLIA_APPLICATION_ID
const ALGOLIA_API_KEY_READ_ONLY = process.env.ALGOLIA_API_KEY_READ_ONLY

async function getFacets() {
	try {
		const res = await axios.get(`${process.env.baseUrl}/custom/loja/facets.json`)
		filtroLateralCategorias = res.data
	} catch (error) {
		console.log(error)
	}
}

async function getAlgoliaQueryStrings() {
	try {
		const res = await axios.get(`${process.env.baseUrl}/custom/loja/algoliaQueryStrings.json`)
		decodeString = res.data
	} catch (error) {
		console.log(error)
	}
}

getFacets()
getAlgoliaQueryStrings()

import algoliasearch from "algoliasearch/lite"
import _renderToString from "vue-server-renderer/basic"
import { getEncodedCategories } from "@/utils/encodedCategories"

const encodedCategories = getEncodedCategories()

function renderToString(app) {
	return new Promise((resolve, reject) => {
		_renderToString(app, (err, res) => {
			if (err) reject(err)
			resolve(res)
		})
	})
}

const decodedCategories = Object.keys(encodedCategories).reduce((acc, key) => {
	const newKey = encodedCategories[key]
	const newValue = key

	return {
		...acc,
		[newKey]: newValue,
	}
}, {})

function getCategorySlug(name) {
	const encodedName = decodedCategories[name] || name
	return encodedName
}

function getCategoryName(slug) {
	const decodedSlug = encodedCategories[slug] || slug
	return decodedSlug.split("+").map(decodeURIComponent).join(" ")
}

export const createRouteStateFromRoute = (route) => {
	const pathnameMatches = route.path.match(/lista\/(.*?)\/?$/)

	const category = getCategoryName((pathnameMatches && pathnameMatches[1]) || "")

	let finalObj = {}

	// route.query da Rota do Vue !== query do Algolia (Busca)
	if (route.query) {
		for (const [key, value] of Object.entries(route.query)) {
			if (route.query[key]) {
				// Quando tem somente um filtro
				if (typeof value === "string" && key !== "query" && key !== "page") {
					finalObj[key] = [value].filter(Boolean)
				} else if (typeof value === "string" && key === "query") {
					finalObj[key] = value
				} else if (typeof value === "string" && key === "page") {
					// Paginação
					finalObj[key] = value
				} else {
					// Mais de um vira um Array
					finalObj[key] = value.map(decodeURIComponent)
				}
			}
		}
	}

	finalObj.category = category

	return finalObj
}

export const createURLFromRouteState = (fullPath, routeState) => {
	const urlParts = fullPath.match(/^(.*?)\/lista/)
	let baseUrl = process.env.baseUrl + "/"

	if (urlParts) {
		const categoryPath = routeState.category ? `${getCategorySlug(routeState.category)}` : ""
		let newQs = {}

		for (const [key, value] of Object.entries(routeState)) {
			if (routeState[key] && key !== "category") {
				if (Array.isArray(routeState[key])) {
					// Filtros
					newQs[key] = routeState[key].map(encodeURIComponent)
				} else {
					// Query
					if (key !== "category" && key !== "page") {
						newQs[key] = routeState[key]
					}
					// Paginação
					if (key === "page") {
						newQs[key] = routeState[key]
					}
				}
			}
		}

		const queryString = qs.stringify(newQs, {
			addQueryPrefix: true,
			arrayFormat: "repeat",
			format: "RFC1738",
		})

		return `${baseUrl}lista/${categoryPath}${queryString}`
	} else {
		return `${process.env.baseUrl}${fullPath}`
	}
}

export const createRouteFromRouteState = (fullPath, routeState) => {
	const url = createURLFromRouteState(fullPath, routeState)

	let newQs = {}

	for (const [key, value] of Object.entries(routeState)) {
		if (routeState[key] && key !== "category") {
			if (Array.isArray(routeState[key])) {
				newQs[key] = routeState[key].map(encodeURIComponent)
			} else {
				// Paginação é um numero e não um Array
				newQs[key] = value
			}
		}
	}

	let path = null
	if (url) {
		path = url.split("?")[0]
	}

	newQs.fullPath = url
	newQs.path = path
	newQs.query = routeState.query

	return newQs
}

function nuxtRouter(vueRouter) {
	return {
		read() {
			return createRouteStateFromRoute(vueRouter.currentRoute)
		},
		write(routeState) {
			// history exists only on client-side
			if (typeof history === "undefined") {
				return
			}

			const fullPath = vueRouter.resolve({
				query: routeState,
			}).href

			const route = createRouteFromRouteState(fullPath, routeState)

			// route variable shape look like this : { path: String, fullPath: String, query: Object }
			// I think its not mandatory to pass this object to replaceState, the important parameter is the third one
			// https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
			history.replaceState(route, "", route.fullPath)
		},
		createURL(routeState) {
			const fullPath = vueRouter.resolve({
				query: routeState,
			}).href

			return createURLFromRouteState(fullPath, routeState)
		},
		// call this callback whenever the URL changed externally
		onUpdate(cb) {
			if (typeof window === "undefined") {
				return
			}
			this._onPopState = (event) => {
				const routeState = event.state
				if (!routeState) {
					cb(this.read())
				} else {
					cb(routeState)
				}
			}
			window.addEventListener("popstate", this._onPopState)
		},
		// remove any listeners
		dispose() {
			if (typeof window === "undefined") {
				return
			}
			window.removeEventListener("popstate", this._onPopState)
		},
	}
}

const searchClient = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_API_KEY_READ_ONLY)

function slugify(string) {
	const a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;"
	const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------"
	const p = new RegExp(a.split("").join("|"), "g")

	return string
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
		.replace(/&/g, "-and-") // Replace & with 'and'
		.replace(/[^\w\-]+/g, "") // Remove all non-word characters
		.replace(/\-\-+/g, "-") // Replace multiple - with single -
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, "") // Trim - from end of text
}

import {
	AisPanel,
	AisToggleRefinement,
	AisClearRefinements,
	AisCurrentRefinements,
	AisHighlight,
	AisHits,
	AisInstantSearchSsr,
	AisPagination,
	AisRefinementList,
	AisSearchBox,
	AisHierarchicalMenu,
	AisBreadcrumb,
	AisConfigure,
	AisStats,
	createServerRootMixin,
	AisStateResults,
} from "vue-instantsearch"
import ProductListItemV2 from "@/components/Product/ProductListItemV2"
export default {
	components: {
		Loader,
		AisPanel,
		AisClearRefinements,
		AisToggleRefinement,
		AisConfigure,
		AisStats,
		AisHierarchicalMenu,
		AisBreadcrumb,
		AisCurrentRefinements,
		AisHighlight,
		AisHits,
		AisInstantSearchSsr,
		AisPagination,
		AisRefinementList,
		AisSearchBox,
		AisStateResults,
		ProductListItemV2,
	},
	data() {
		const mixin = createServerRootMixin({
			searchClient,
			indexName: ALGOLIA_INDEX_PRODUCTS,
			routing: {
				router: nuxtRouter(this.$router),
				stateMapping: {
					stateToRoute(uiState) {
						// Convert uiState to routeState
						// uistate na Rota

						const indexUiState = uiState[ALGOLIA_INDEX_PRODUCTS]

						if (Object.entries(indexUiState).length === 0) {
							return {}
							// 	return { disableWriteBuggyState: true }
						}

						let objeto = {}
						objeto = filtroLateralCategorias

						let objetoFinal = {}
						if (indexUiState.refinementList) {
							// Loop pelo .json
							for (let [key, value] of Object.entries(indexUiState.refinementList)) {
								// Pega o valor da chave e verifica se está no indexUiState.refinementList[key]
								objetoFinal[key] = indexUiState.refinementList[key]
							}
						}

						if (Object.keys(objetoFinal).length > 0) {
							// Verifica se tem algum filtro e faz o loop
							for (let [key, value] of Object.entries(objetoFinal)) {
								let arraySlug = []
								for (let iterator of value) {
									// Aqui tem que fazer o slugify das rotas
									if (key === "category" || key === "grupo" || key === "veiculo" || key === "ano") {
										arraySlug.push(slugify(iterator))
									} else {
										// Parametros extras, ex: utm
										arraySlug.push(iterator)
									}
								}
								objetoFinal[key] = arraySlug
							}
						}

						objetoFinal.query = indexUiState.query
						objetoFinal.category = indexUiState.hierarchicalMenu && indexUiState.hierarchicalMenu["categoria_hierarquical.lvl0"] && indexUiState.hierarchicalMenu["categoria_hierarquical.lvl0"].join("/")
						objetoFinal.page = indexUiState.page

						return objetoFinal
					},
					routeToState(routeState) {
						// routeState becomes the URL
						// veiculo: ['gol']

						let objeto = {}
						objeto = filtroLateralCategorias
						let objetoFinal = {}

						// Verifica se tem algum facet no Objeto
						if (Object.keys(routeState).length > 0) {
							for (const [key, value] of Object.entries(routeState)) {
								let arrayPadraoAlgolia = []
								// Faz o tratamento se for Facet
								if (routeState[key] && typeof routeState[key] !== "string") {
									if (key === "grupo" || key === "veiculo" || key === "ano") {
										// Tratamento dos Filtros normais
										for (let iterator of value) {
											// Aqui tem que fazer o deslugify para ficar no padrão Algolia
											if (decodeString[iterator]) {
												arrayPadraoAlgolia.push(decodeString[iterator])
											}
										}

										routeState[key] = arrayPadraoAlgolia

										// Tratamento das Caracteristicas
										let oldkey = key
										if (key.includes("+")) {
											let str = String(key) || ""
											str = str.replace(/\+/g, " ")
											routeState[str] = value
											delete routeState[oldkey]
										}
									}
								}
							}
						}

						return {
							[ALGOLIA_INDEX_PRODUCTS]: {
								refinementList: routeState,
								page: routeState.page,
								query: routeState.query,
								hierarchicalMenu: {
									"categoria_hierarquical.lvl0": (routeState.category && routeState.category.split("/")) || undefined,
								},
							},
						}
					},
				},
			},
		})

		return {
			filtrosLaterais: filtroLateralCategorias,
			showNav: false,
			geolocation: null,
			isLoading: true,
			atributosParaLimpar: ["query", "grupo", "veiculo", "ano", "category"],
			...mixin.data(),
		}
	},
	methods: {
		meLocalize() {
			this.$eventbus.$emit("ComponentMinhaLocalizacao/abrir")
		},
		triggerAlgoliaClick(e, produto, produtoIndex) {
			let userToken = this.$cookies.get("_ALGOLIA")
			let objectId = produto.objectID
			let produtoPosition = produtoIndex + 1

			let payloadAlgolia = {
				userToken: userToken,
				index: ALGOLIA_INDEX_PRODUCTS,
				eventName: "Product Clicked",
				queryID: produto.__queryID,
				objectIds: [objectId],
				positions: [produtoPosition],
			}

			window.aa("clickedObjectIDsAfterSearch", payloadAlgolia)
		},
		triggerSearchButton(refine) {
			let searchField = document.querySelector("#searchbox #inputSearch")
			document.querySelector("#clearRefinementSearch button").click()
			refine(searchField.value)
		},
		refineSearch(refine, value) {
			document.querySelector("#clearRefinementSearch button").click()
			refine(value)
		},
		clearQuery(refine) {
			refine()
			document.querySelector("#searchbox form").reset()
		},
		triggerNav() {
			let leftPanel = document.getElementById("leftPanel")
			let backdrop = document.getElementById("backdrop")
			if (leftPanel.classList.contains("active")) {
				leftPanel.classList.remove("active")
			} else {
				leftPanel.classList.add("active")
			}

			if (backdrop.classList.contains("active")) {
				backdrop.classList.remove("active")
			} else {
				backdrop.classList.add("active")
			}
		},
		formatRefinementLabel(string) {
			if (string.includes(".")) {
				if (string.includes("Filtro_lateral")) {
					return string.replace("Filtro_lateral.", "")
				}
				if (string.includes("Categoria_")) {
					return "Categoria"
				}
			}
			return string
		},
		truncateString(input, maxLength) {
			if (input.length > maxLength) {
				return input.substring(0, maxLength) + "..."
			}
			return input
		},
		updateCepRules() {
			this.geolocation = this.$storage.getUniversal("geolocation")
		},
	},
	head() {
		let head = {}

		head.meta = []

		if (this.itemMarketingSelecionado) {
			head.title = this.itemMarketingSelecionado.meta.title

			head.meta.push(
				{
					hid: "description",
					name: "description",
					content: this.itemMarketingSelecionado.meta.description,
				},
				{
					property: "og:title",
					content: this.itemMarketingSelecionado.og.title || this.itemMarketingSelecionado.meta.title,
				},
				{
					property: "og:description",
					content: this.itemMarketingSelecionado.og.description || this.itemMarketingSelecionado.meta.description,
				}
			)
		}
		return head
	},
	provide() {
		return {
			// Provide the InstantSearch instance for SSR
			$_ais_ssrInstantSearchInstance: this.instantsearch,
		}
	},
	async serverPrefetch() {
		return this.instantsearch.findResultsState({ component: this, renderToString }).then((algoliaState) => {
			this.$ssrContext.nuxt.algoliaState = algoliaState
		})
	},
	beforeMount() {
		const results = (this.$nuxt.context && this.$nuxt.context.nuxtState.algoliaState) || window.__NUXT__.algoliaState

		this.instantsearch.hydrate(results)

		// Remove the SSR state so it can't be applied again by mistake
		delete this.$nuxt.context.nuxtState.algoliaState
		delete window.__NUXT__.algoliaState
	},
	mounted() {
		/** Para o reload e filtros de facets normal se manter, precisa estar no algoliaQueryStrings */
		this.updateCepRules()

		/** Algolia Analytcs */
		window.aa("init", {
			appId: "JPW9SFM280",
			apiKey: "921eed61ec24f8facc2b777b74bffb21",
			useCookie: true,
		})

		// Isso aqui tem muito efeito colateral
		// let vm = this
		// this.$refs.aisInstantSearchSsr.instantSearchInstance.use(() => {
		// 	return {
		// 		onStateChange({uiState}) {
		// 			// if (vm.$refs.marketingInfo) {
		// 			// 	vm.$refs.marketingInfo.classList.add("hidden")
		// 			// }
		// 		},
		// 	}
		// })

		this.isLoading = false
	},
	unmounted() {
		this.isLoading = true
	},
	computed: {
		selecionouCidade() {
			return this.$store.getters["selecionouCidade"]
		},
		cidadeEstado() {
			if (this.selecionouCidade) {
				let geolocation = this.$cookies.get("geolocation")
				return geolocation.cidade_uf
			} else {
				return
			}
		},
		availableStores() {
			return this.$store.getters["availableStores"]
		},
		itemMarketingSelecionado() {
			const marketingInfo = this.$store.getters["marketingJson"]
			let itemSelecionado
			let currentRoute = `/lista/${this.$route.params.pathMatch}`

			// Necessário esse fix para pegar a rota correta, o pathMatch (quando não é SSR) adiciona uma / a mais
			// currentRoute = currentRoute.substring(0, currentRoute.length - 1)

			for (let [key, value] of Object.entries(marketingInfo)) {
				if (key === currentRoute) {
					itemSelecionado = value
				}
			}
			return itemSelecionado
		},
	},
}
</script>

<style lang="scss">
.lista2 {
	.ais-Hits-list {
		margin-top: 0;
		margin-bottom: 1em;
		display: grid;
		grid-template-columns: 1fr;
		@media (min-width: 768px) {
			grid-template-columns: 1fr 1fr 1fr;
		}
	}

	.ais-InstantSearch {
		overflow: hidden;
		position: relative;
	}

	.panels {
		@media (min-width: 768px) {
			display: grid;
			grid-template-columns: 1fr 4fr;
			grid-gap: 32px;
		}
	}

	.ais-Hits-item {
		display: flex;
		flex-direction: column;
		padding: 0;
		box-shadow: none;
	}
	.ais-Hits-item img {
		margin-right: 1em;
	}
	.hit-name {
		margin-bottom: 0.5em;
	}
	.hit-description {
		color: #888;
		font-size: 0.8em;
		margin-bottom: 0.5em;
	}
	.ais-CurrentRefinements {
		margin: 0;
	}
	.ais-CurrentRefinements-list {
		gap: 8px !important;
		flex-wrap: wrap;
		display: flex;
	}
	.ais-CurrentRefinements-item {
		display: flex;
		gap: 8px;
		border: none;
		background-color: transparent;
		margin: 0;
		padding: 0 !important;
	}
	.current-refinement-chip {
		display: flex;
		align-items: center;
		margin: 0;
		border-radius: 5px;
		padding: 5px 20px;
		background-color: #c2cacf;
		border: none;
		cursor: pointer;
		color: #3c484d;
		a {
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			letter-spacing: 0.09px;
			display: flex;
			align-items: center;
		}
	}
	.ais-ClearRefinements {
		margin-bottom: 16px;
	}
	.ais-Panel {
		margin-bottom: 16px;
		padding: 0 !important;
	}
	.ais-Panel-header {
		text-transform: none;
		font-size: 16px !important;
		padding-bottom: 16px !important;
		margin-bottom: 0;
	}
	.ais-Panel.ais-Panel--noRefinement {
		display: none;
	}
	.ais-RefinementList-list {
		max-height: 240px;
		overflow: auto;
	}
	.ais-RefinementList-item {
		// Altura não bate com o padrão 16px
		margin-bottom: 12px;
		padding-bottom: 0 !important;
	}
	.ais-RefinementList-item:last-of-type {
		margin-bottom: 8px;
	}
	.ais-Hits {
		margin-top: 16px;
	}
	.ais-Hits-list {
		display: flex;
		flex-direction: column;
		gap: 16px !important;
	}
	.ais-Hits-item img {
		margin-right: 0 !important;
	}
	.ais-CurrentRefinements--noRefinement {
		display: none;
	}
	.left-panel {
		position: fixed;
		left: 0;
		top: 0;
		transform: translateX(-100%);
		transition: all 0.5s ease-in-out;
		background-color: #fff;
		z-index: 9999;
		width: 90vw;
		height: 100vh;
		padding: 16px;
		overflow: auto;
		&.active {
			transform: translateX(0);
		}
		@media (min-width: 768px) {
			position: relative;
			transform: none;
			left: inherit;
			width: inherit;
			height: inherit;
			padding: 0;
			z-index: inherit;
			width: 306px;
		}
	}
	.backdrop {
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		left: 0;
		top: 0;
		height: 100vh;
		width: 100vw;
		z-index: 9998;
		opacity: 0;
		display: none;
		&.active {
			display: block;
			opacity: 1;
		}
		@media (min-width: 768px) {
			&.active {
				display: none;
			}
		}
	}
	.encontramos-text {
		color: #6f6f6f;
		line-height: 1;
		b {
			color: #3c484d;
		}
	}
}

.ais-CurrentRefinements-list,
.ais-HierarchicalMenu-list,
.ais-Hits-list,
.ais-Results-list,
.ais-InfiniteHits-list,
.ais-InfiniteResults-list,
.ais-Menu-list,
.ais-NumericMenu-list,
.ais-Pagination-list,
.ais-RatingMenu-list,
.ais-RefinementList-list,
.ais-ToggleRefinement-list {
	margin: 0;
	padding: 0;
	list-style: none;
}

.ais-ClearRefinements-button,
.ais-CurrentRefinements-delete,
.ais-CurrentRefinements-reset,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset,
.ais-HierarchicalMenu-showMore,
.ais-InfiniteHits-loadPrevious,
.ais-InfiniteHits-loadMore,
.ais-InfiniteResults-loadMore,
.ais-Menu-showMore,
.ais-RangeInput-submit,
.ais-RefinementList-showMore,
.ais-SearchBox-submit,
.ais-SearchBox-reset,
.ais-VoiceSearch-button {
	padding: 0;
	overflow: visible;
	font: inherit;
	line-height: normal;
	color: inherit;
	background: none;
	border: 0;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
}
.ais-ClearRefinements-button::-moz-focus-inner,
.ais-CurrentRefinements-delete::-moz-focus-inner,
.ais-CurrentRefinements-reset::-moz-focus-inner,
.ais-GeoSearch-redo::-moz-focus-inner,
.ais-GeoSearch-reset::-moz-focus-inner,
.ais-HierarchicalMenu-showMore::-moz-focus-inner,
.ais-InfiniteHits-loadPrevious::-moz-focus-inner,
.ais-InfiniteHits-loadMore::-moz-focus-inner,
.ais-InfiniteResults-loadMore::-moz-focus-inner,
.ais-Menu-showMore::-moz-focus-inner,
.ais-RangeInput-submit::-moz-focus-inner,
.ais-RefinementList-showMore::-moz-focus-inner,
.ais-SearchBox-submit::-moz-focus-inner,
.ais-SearchBox-reset::-moz-focus-inner,
.ais-VoiceSearch-button::-moz-focus-inner {
	padding: 0;
	border: 0;
}
.ais-ClearRefinements-button[disabled],
.ais-CurrentRefinements-delete[disabled],
.ais-CurrentRefinements-reset[disabled],
.ais-GeoSearch-redo[disabled],
.ais-GeoSearch-reset[disabled],
.ais-HierarchicalMenu-showMore[disabled],
.ais-InfiniteHits-loadPrevious[disabled],
.ais-InfiniteHits-loadMore[disabled],
.ais-InfiniteResults-loadMore[disabled],
.ais-Menu-showMore[disabled],
.ais-RangeInput-submit[disabled],
.ais-RefinementList-showMore[disabled],
.ais-SearchBox-submit[disabled],
.ais-SearchBox-reset[disabled],
.ais-VoiceSearch-button[disabled] {
	cursor: default;
}

.ais-InfiniteHits-loadPrevious,
.ais-InfiniteHits-loadMore,
.ais-HierarchicalMenu-showMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
	overflow-anchor: none;
}

.ais-Breadcrumb-list,
.ais-Breadcrumb-item,
.ais-Pagination-list,
.ais-RangeInput-form {
	display: flex;
	align-items: center;
}
.ais-Breadcrumb-list {
	flex-wrap: wrap;
}

.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list {
	margin-left: 1em;
}

.ais-SearchBox-input::-ms-clear,
.ais-SearchBox-input::-ms-reveal {
	display: none;
	width: 0;
	height: 0;
}
.ais-SearchBox-input::-webkit-search-decoration,
.ais-SearchBox-input::-webkit-search-cancel-button,
.ais-SearchBox-input::-webkit-search-results-button,
.ais-SearchBox-input::-webkit-search-results-decoration {
	display: none;
}

.rheostat-handle {
	position: relative;
	z-index: 1;
	width: 20px;
	height: 20px;
	background-color: #fff;
	border: 1px solid #333;
	border-radius: 50%;
	cursor: grab;
}

.rheostat-marker {
	margin-left: -1px;
	position: absolute;
	width: 1px;
	height: 5px;
	background-color: #aaa;
}

.rheostat-marker--large {
	height: 9px;
}

.rheostat-value {
	margin-left: 50%;
	padding-top: 15px;
	position: absolute;
	text-align: center;
	transform: translateX(-50%);
}

.rheostat-tooltip {
	margin-left: 50%;
	position: absolute;
	top: -22px;
	text-align: center;
	transform: translateX(-50%);
}

/**
 * Reset
 */
[class^="ais-"] {
	box-sizing: border-box;
}

/**
 * Disabled
 */
[class^="ais-"][class$="--disabled"],
[class^="ais-"][class$="--disabled"] *,
.ais-VoiceSearch-button:disabled {
	cursor: not-allowed;
}

/**
 * Buttons
 */
.ais-HierarchicalMenu-showMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore,
.ais-ClearRefinements-button,
.ais-InfiniteHits-loadMore,
.ais-RangeInput-submit,
.ais-InfiniteHits-loadPrevious,
.ais-Pagination-link,
.ais-VoiceSearch-button,
.ais-RelevantSort-button {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-color: #fff;
	background-image: linear-gradient(-180deg, #fff, #fcfcfd);
	border: 1px solid #d6d6e7;
	border-radius: 3px;
	box-shadow: 0 1px 0 0 rgba(35, 38, 59, 0.05);
	color: #23263b;
	cursor: pointer;
	display: inline-flex;
	font-size: 0.875rem;
	font-weight: 400;
	height: 2rem;
	justify-content: center;
	line-height: 1.25rem;
	padding: 0 1rem;
	place-items: center;
	text-decoration: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
}

.ais-HierarchicalMenu-showMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore,
.ais-GeoSearch-redo,
.ais-GeoSearch-reset {
	height: 1.5rem;
}

.ais-HierarchicalMenu-showMore,
.ais-Menu-showMore,
.ais-RefinementList-showMore {
	margin-top: 1rem;
}

.ais-HierarchicalMenu-showMore:hover,
.ais-Menu-showMore:hover,
.ais-RefinementList-showMore:hover,
.ais-ClearRefinements-button:hover,
.ais-InfiniteHits-loadMore:hover,
.ais-RangeInput-submit:hover,
.ais-InfiniteHits-loadPrevious:hover,
.ais-Pagination-item:not(.ais-Pagination-item--selected):not(.ais-Pagination-item--disabled) .ais-Pagination-link:hover,
.ais-GeoSearch-redo:hover,
.ais-GeoSearch-reset:hover,
.ais-VoiceSearch-button:hover {
	background-image: linear-gradient(-180deg, #fff, #f5f5fa);
	border-color: #d6d6e7;
}

.ais-HierarchicalMenu-showMore:focus,
.ais-Menu-showMore:focus,
.ais-RefinementList-showMore:focus,
.ais-ClearRefinements-button:focus,
.ais-InfiniteHits-loadMore:focus,
.ais-RangeInput-submit:focus,
.ais-InfiniteHits-loadPrevious:focus,
.ais-GeoSearch-redo:focus,
.ais-GeoSearch-reset:focus,
.ais-VoiceSearch-button:focus {
	background-image: linear-gradient(-180deg, #fff, #f5f5fa);
	border-color: #3c4fe0;
	box-shadow: #3c4fe0 0 0 0 1px, rgba(35, 38, 59, 0.05) 0 2px 0 1px;
	outline: currentcolor none medium;
}

.ais-HierarchicalMenu-showMore:active,
.ais-Menu-showMore:active,
.ais-RefinementList-showMore:active,
.ais-ClearRefinements-button:active,
.ais-InfiniteHits-loadMore:active,
.ais-InfiniteHits-loadPrevious:active,
.ais-Pagination-item--selected .ais-Pagination-link,
.ais-Pagination-link:active,
.ais-GeoSearch-redo:active,
.ais-GeoSearch-reset:active,
.ais-VoiceSearch-button:active {
	border-color: #d6d6e7;
	box-shadow: rgba(119, 122, 175, 0.4) 0 1px 4px 0 inset, rgba(119, 122, 175, 0.4) 0 1px 1px 0 inset, rgba(35, 38, 59, 0.05) 0 1px 0 0;
}

.ais-ClearRefinements-button:disabled[disabled],
.ais-InfiniteHits-loadMore:disabled[disabled],
.ais-InfiniteHits-loadPrevious:disabled[disabled],
.ais-Pagination-item--disabled .ais-Pagination-link,
.ais-GeoSearch-redo--disabled,
.ais-GeoSearch-reset--disabled,
.ais-VoiceSearch-button:disabled {
	background-image: linear-gradient(-180deg, #fff, #f5f5fa);
	border-color: #efeff5;
	box-shadow: none;
	color: #b6b7d5;
}

.ais-HierarchicalMenu-showMore--disabled[disabled],
.ais-Menu-showMore--disabled[disabled],
.ais-RefinementList-showMore--disabled[disabled] {
	display: none;
}

/**
 * Labels
 */
.ais-NumericMenu-label,
.ais-ToggleRefinement-label,
.ais-HierarchicalMenu-item,
.ais-Menu-item,
.ais-RatingMenu-item,
.ais-RefinementList-item {
	display: block;
	font-size: 0.875rem;
	line-height: 1.75rem;
}

.ais-HierarchicalMenu-link,
.ais-Menu-link,
.ais-RatingMenu-link,
.ais-RefinementList-label {
	align-items: center;
	cursor: pointer;
	display: flex;
	flex-wrap: nowrap;
}

.ais-Breadcrumb-link,
.ais-HierarchicalMenu-link,
.ais-Menu-link,
.ais-RatingMenu-link {
	color: inherit;
	text-decoration: none;
}

.ais-HierarchicalMenu-link {
	margin-bottom: 8px;
}

.ais-Breadcrumb-link:hover {
	text-decoration: underline;
}

.ais-HierarchicalMenu-label,
.ais-Menu-label,
.ais-RefinementList-labelText {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.ais-HierarchicalMenu-label {
	font-family: var(--head-regular);
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0;
}

.ais-RefinementList-labelText {
	font-family: var(--head-regular);
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0;
}
.ais-RefinementList-labelText::first-letter {
	text-transform: capitalize;
}

.ais-HierarchicalMenu-item--selected > .ais-HierarchicalMenu-link > .ais-HierarchicalMenu-label,
.ais-Menu-item--selected .ais-Menu-label,
.ais-RefinementList-item--selected,
.ais-RatingMenu-item--selected {
	font-weight: 600;
}

.ais-HierarchicalMenu-item--selected > .ais-HierarchicalMenu-link > .ais-HierarchicalMenu-label {
	font-family: var(--head-bold);
}

/**
 * Count
 */
.ais-ToggleRefinement-count,
.ais-HierarchicalMenu-count,
.ais-Menu-count,
.ais-RatingMenu-count,
.ais-RefinementList-count {
	background: #f5f5fa none repeat scroll 0% 0%;
	border: 1px solid #b6b7d5;
	border-radius: 99999px;
	color: #23263b;
	display: inline-flex;
	flex-shrink: 0;
	font-size: 0.75rem;
	font-weight: 400;
	line-height: 1rem;
	margin-left: 0.5rem;
	overflow: hidden;
	padding: 0 0.25rem;
}
.ais-HierarchicalMenu-count {
	display: none;
}

/**
 * No Results
 */
.ais-Menu-noResults,
.ais-HierarchicalMenu-noResults,
.ais-RefinementList-noResults {
	color: #5a5e9a;
	font-size: 0.875rem;
	line-height: 1.25rem;
	margin-top: 1rem;
}

/**
 * Selectors
 */
.ais-MenuSelect-select,
.ais-HitsPerPage-select,
.ais-SortBy-select {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-color: #fff;
	background-image: url('data:image/svg+xml;utf8,<svg width="14" height="24" xmlns="http://www.w3.org/2000/svg"><g stroke="%23777aaf" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M13 7L7 1 1 7M1 17l6 6 6-6"/></g></svg>'), linear-gradient(-180deg, #fff, #fcfcfd);
	background-position: right 1rem center, 0 0;
	background-repeat: no-repeat;
	background-size: 10px, auto;
	border: 1px solid #d6d6e7;
	border-radius: 3px;
	box-shadow: rgba(35, 38, 59, 0.05) 0 1px 0 0;
	color: #23263b;
	cursor: pointer;
	font: inherit;
	height: 2.5rem;
	outline: currentcolor none medium;
	padding: 0 2.5rem 0 1rem;
	position: relative;
	width: 100%;
}

.ais-HitsPerPage-select:-moz-focusring,
.ais-HitsPerPage-select::-moz-focus-inner,
.ais-SortBy-select:-moz-focusring,
.ais-SortBy-select::-moz-focus-inner {
	color: transparent;
	outline: currentcolor none medium;
}

.ais-HitsPerPage-select > option:not(:checked),
.ais-SortBy-select > option:not(:checked) {
	color: #23263b;
}

.ais-HitsPerPage-select > option:disabled,
.ais-SortBy-select > option:disabled {
	color: #b6b7d5;
}

.ais-HitsPerPage-select:hover,
.ais-SortBy-select:hover {
	background-image: url('data:image/svg+xml;utf8,<svg width="14" height="24" xmlns="http://www.w3.org/2000/svg"><g stroke="%23777aaf" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M13 7L7 1 1 7M1 17l6 6 6-6"/></g></svg>'), linear-gradient(-180deg, #fcfcfd, #f5f5fa);
	border-color: #d6d6e7;
}

.ais-HitsPerPage-select:focus,
.ais-SortBy-select:focus {
	background-image: url('data:image/svg+xml;utf8,<svg width="14" height="24" xmlns="http://www.w3.org/2000/svg"><g stroke="%23777aaf" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M13 7L7 1 1 7M1 17l6 6 6-6"/></g></svg>'), linear-gradient(-180deg, #fff, #f5f5fa);
	border-color: #3c4fe0;
	box-shadow: #3c4fe0 0 0 0 1px, rgba(35, 38, 59, 0.05) 0 2px 0 0;
}

.ais-HitsPerPage-select:disabled,
.ais-SortBy-select:disabled {
	background-image: url('data:image/svg+xml;utf8,<svg width="14" height="24" xmlns="http://www.w3.org/2000/svg"><g stroke="%23b6b7d5" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M13 7L7 1 1 7M1 17l6 6 6-6"/></g></svg>'), linear-gradient(-180deg, #fff, #f5f5fa);
	border-color: #efeff5;
	box-shadow: none;
	color: #b6b7d5;
	cursor: not-allowed;
}

/**
 * Panel
 */
.ais-Panel {
	margin-bottom: 2rem;
}

.ais-Panel-header {
	color: #5a5e9a;
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1rem;
	margin-bottom: 1rem;
	text-transform: uppercase;
}

.ais-Panel-footer {
	color: #5a5e9a;
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1rem;
	margin-top: 1rem;
}

.ais-Panel--collapsible {
	position: relative;
}

.ais-Panel--collapsible .ais-Panel-collapseButton {
	background: none;
	border: none;
	padding: 0;
	position: absolute;
	right: 0;
	top: 0;
}

.ais-Panel--collapsed .ais-Panel-body,
.ais-Panel--collapsed .ais-Panel-footer {
	display: none;
}

/**
 * SearchBox
 */
.ais-SearchBox-form {
	background-color: #fff;
	display: flex;
	font-size: 0.875rem;
	height: 2.5rem;
	line-height: 1.25rem;
	position: relative;
	width: 100%;
}

.ais-SearchBox-input {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-color: #fff;
	border: 1px solid #d6d6e7;
	border-radius: 3px;
	box-shadow: rgba(119, 122, 175, 0.3) 0 1px 4px 0 inset;
	caret-color: var(--primary_color);
	color: #23263b;
	flex: 1 1 0%;
	font: inherit;
	max-width: 100%;
	padding-left: 1rem;
	padding-right: 3.5rem;
}

.ais-SearchBox-input::-moz-placeholder {
	color: var(--primary_color);
}

.ais-SearchBox-input::placeholder {
	color: var(--primary_color);
	font-size: 14px;
	@media (min-width: 768px) {
		font-size: 16px;
	}
}

.ais-SearchBox-input:focus {
	border-color: var(--primary_color);
	box-shadow: rgba(35, 38, 59, 0.05) 0 1px 0 0;
	outline: currentcolor none medium;
}

.ais-SearchBox-input:disabled {
	background: rgba(0, 0, 0, 0) linear-gradient(-180deg, #fff, #f5f5fa) repeat scroll 0% 0%;
	border-color: #efeff5;
	box-shadow: none;
	cursor: not-allowed;
}

.ais-SearchBox-input:disabled::-moz-placeholder {
	color: #b6b7d5;
	pointer-events: none;
}

.ais-SearchBox-input:disabled::placeholder {
	color: #b6b7d5;
	pointer-events: none;
}

.ais-SearchBox-input::-webkit-search-cancel-button,
.ais-SearchBox-input::-webkit-search-decoration,
.ais-SearchBox-input::-webkit-search-results-button,
.ais-SearchBox-input::-webkit-search-results-decoration {
	-webkit-appearance: none;
	appearance: none;
}

.ais-SearchBox-loadingIndicator,
.ais-SearchBox-reset {
	align-items: center;
	border-radius: 50%;
	display: flex;
	fill: #484c7a;
	height: 20px;
	justify-content: center;
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);
	width: 20px;
}

.ais-SearchBox-reset:focus {
	background: #b6b7d5;
	fill: #fff;
	outline: 0;
}

.ais-RefinementList-searchBox .ais-SearchBox-loadingIndicator,
.ais-RefinementList-searchBox .ais-SearchBox-reset {
	right: 0.5rem;
}

.ais-SearchBox-loadingIndicator[hidden],
.ais-SearchBox-reset[hidden] {
	display: none;
}

.ais-SearchBox-submit {
	display: none;
}

.ais-Menu-searchBox,
.ais-RefinementList-searchBox {
	margin-bottom: 0.5rem;
}

.ais-Menu-searchBox .ais-SearchBox-form,
.ais-RefinementList-searchBox .ais-SearchBox-form {
	height: 2rem;
}

.ais-Menu-searchBox .ais-SearchBox-form::before,
.ais-RefinementList-searchBox .ais-SearchBox-form::before {
	left: 0.5rem;
}

.ais-Menu-searchBox .ais-SearchBox-input,
.ais-RefinementList-searchBox .ais-SearchBox-input {
	padding-left: 2rem;
}

.ais-RefinementList-searchBox .ais-SearchBox-input {
	padding-left: 16px;
}

.ais-RefinementList-searchBox .ais-SearchBox-input::placeholder {
	font-family: var(--head-regular);
}

/**
 * Highlighting and Snippeting
 */

.ais-Highlight-highlighted,
.ais-Snippet-highlighted {
	background-color: rgba(84, 104, 255, 0.1);
	color: #5468ff;
	font-style: normal;
}

/**
 * ReverseHighlighting and ReverseSnippeting
 */
.ais-ReverseHighlight-highlighted,
.ais-ReverseSnippet-highlighted {
	font-weight: bold;
	font-style: normal;
	background: none;
}

/**
 * Hits
 */
.ais-Hits-item,
.ais-InfiniteHits-item {
	align-items: center;
	background: #fff;
	box-shadow: 0 0 0 1px rgba(35, 38, 59, 0.05), 0 1px 3px 0 rgba(35, 38, 59, 0.15);
	display: flex;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.25rem;
	padding: 1.5rem;
}

.ais-Hits-item:first-of-type,
.ais-InfiniteHits-item:first-of-type {
	border-radius: 3px 3px 0 0;
}

.ais-Hits-item:last-of-type,
.ais-InfiniteHits-item:last-of-type {
	border-radius: 0 0 3px 3px;
}

.ais-Hits-item:only-of-type,
.ais-InfiniteHits-item:only-of-type {
	border-radius: 3px;
}

.ais-InfiniteHits-loadMore,
.ais-InfiniteHits-loadPrevious {
	display: flex;
	margin: 1rem auto;
}

/**
 * RefinementList
 */
.ais-RefinementList-checkbox,
.ais-GeoSearch-input {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-color: #fff;
	background-position: 50%;
	background-size: 180%;
	border: 1px solid currentcolor;
	border-radius: 3px;
	box-shadow: inset 0 1px 4px 0 rgba(119, 122, 175, 0.4);
	color: #d6d6e7;
	cursor: inherit;
	height: 1rem;
	margin: 0 0.5rem 0 0;
	min-width: 1rem;
}

.ais-RefinementList-item--selected .ais-RefinementList-checkbox,
.ais-GeoSearch-input:checked {
	background-image: url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%235468ff%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%2220%206%209%2017%204%2012%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
	background-size: 14px;
	border-color: currentcolor;
	box-shadow: rgba(35, 38, 59, 0.05) 0 1px 0 0 inset;
	color: #3c4fe0;
}

.ais-RefinementList-checkbox:focus,
.ais-GeoSearch-input:focus {
	outline: currentcolor none medium;
}

.ais-RefinementList-item--selected .ais-RefinementList-checkbox:focus,
.ais-GeoSearch-input:checked:focus {
	// box-shadow: rgba(35, 38, 59, 0.05) 0 1px 0 0 inset, currentcolor 0 0 0 1px;
	border: rgba(35, 38, 59, 0.05) 0 1px 0 0 inset, currentcolor 0 0 0 1px;
}

/**
 * HierarchicalMenu
 */
.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list {
	margin-left: 8px;
}

.ais-HierarchicalMenu-link::before {
	background-image: url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23b6b7d5%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%2218%2015%2012%209%206%2015%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
	background-repeat: no-repeat;
	content: "";
	display: inline-block;
	height: 1rem;
	margin-right: 0.5rem;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
	width: 1rem;
}

.ais-HierarchicalMenu-item--selected > .ais-HierarchicalMenu-link::before {
	background-image: url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%235468ff%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
}

/**
 * ClearRefinements
 */
.ais-ClearRefinements-button {
	width: 100%;
}

/**
 * CurrentRefinements
 */
.ais-CurrentRefinements-list {
	display: inline-grid;
	gap: 1rem;
	grid-auto-flow: column;
}

.ais-CurrentRefinements-item {
	align-items: center;
	background-color: #f5f5fa;
	border: 1px solid #b6b7d5;
	border-radius: 3px;
	display: flex;
	display: inline-flex;
	font-size: 0.875rem;
	line-height: 1.5;
	min-height: 1.5rem;
	padding: 0.05rem 0.5rem;
}

.ais-CurrentRefinements-category {
	display: flex;
	margin-left: 0.5rem;
}

.ais-CurrentRefinements-delete {
	color: #9698c3;
	height: 100%;
	margin-left: 0.25rem;
	outline-width: 0;
}

/**
 * ToggleRefinement
 */
.ais-ToggleRefinement-label {
	align-items: center;
	cursor: pointer;
	display: flex;
	flex-direction: row-reverse;
	justify-content: space-between;
}

.ais-ToggleRefinement-checkbox {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background: rgba(65, 66, 71, 0.08);
	background: #f5f5fa;
	border-radius: 9999px;
	box-shadow: inset 0 1px 4px 0 rgba(119, 122, 175, 0.4);
	height: 18px;
	pointer-events: none;
	position: relative;
	width: 32px;
}

.ais-ToggleRefinement-checkbox:checked {
	background: #3c4fe0;
	box-shadow: inset 0 1px 4px 0 rgba(35, 38, 59, 0.1);
}

.ais-ToggleRefinement-checkbox:focus {
	outline: 0;
}

.ais-ToggleRefinement-checkbox::after {
	background: linear-gradient(-180deg, #fff, #f5f5fa);
	border-radius: 9999px;
	box-shadow: 1px 1px 1px 0 rgba(35, 38, 59, 0.05);
	content: "";
	height: 16px;
	left: 1px;
	position: absolute;
	top: 1px;
	transition: all 100ms ease-in-out;
	width: 16px;
}

.ais-ToggleRefinement-checkbox:checked::after {
	transform: translateX(14px);
}

/**
 * Pagination
 */
.ais-Pagination-item:first-child > .ais-Pagination-link {
	border-radius: 3px 0 0 3px;
}

.ais-Pagination-item + .ais-Pagination-item > .ais-Pagination-link {
	border-radius: 0;
	margin-left: -1px;
}

.ais-Pagination-item:last-child > .ais-Pagination-link {
	border-radius: 0 3px 3px 0;
}

.ais-Pagination-item {
	display: inline-block;
}

.ais-Pagination-item--selected .ais-Pagination-link {
	font-weight: bold;
}

/**
 * Breadrumb
 */
.ais-Breadcrumb-link,
.ais-Breadcrumb-separator {
	color: #3c484d;
	font-family: var(--head-bold);
}
.ais-Breadcrumb-link {
	font-size: 16px;
	font-weight: 300;
	line-height: 19px;
	color: #3c484d;
}

.ais-Breadcrumb-separator {
	display: flex;
	margin: 0 0.5rem;
}

.ais-Breadcrumb-item--selected {
	color: #3c484d;
	font-family: var(--head-bold);
}

.ais-Breadcrumb-item--selected .ais-Breadcrumb-separator {
	font-weight: normal;
}

::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #ffffff;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #c2c2c2;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #555;
}
.marketing-info {
	gap: 10px; // Para alinhar com o filtro lateral desktop
	margin-bottom: 16px;
	h1 {
		font-size: 24px;
		line-height: 1;
	}
	h2 {
		font-size: 16px;
	}
}
.default-list {
	display: grid;
	grid-row-gap: 8px;
	row-gap: 8px;
	padding: 0px 0px 0px 8px;
	li {
		&::before {
			content: "—";
			transform: translateY(-0.05em);
			font-weight: bold;
			margin-right: 8px;
		}
	}
}
.svg-search {
	position: absolute;
	height: 1rem;
	left: 1rem;
	margin-top: -0.5rem;
	position: absolute;
	top: 50%;
	width: 1rem;
}
.lupa-busca {
	position: absolute;
	right: 1rem;
	top: 50%;
	margin-top: -13px;
}
</style>
